export default __webpack_public_path__ + "static/media/Icon-angle-left.c01f8832.svg";